import React from 'react';
import ReactDOM from 'react-dom';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';


//import css in order
import 'bootstrap/dist/css/bootstrap.css';
import 'lightbox2/dist/css/lightbox.min.css';
import 'normalize.css';
import './animate.css';
import './img/font-awesome/css/font-awesome.css';
import './img/icons/css/ionicons.css';
import './style.css';

//import js libraries
import 'bootstrap/dist/js/bootstrap.min.js';
import 'jquery/dist/jquery.min.js';
import 'lightbox2/dist/js/lightbox.min.js';
import 'popper.js/dist/popper.min.js';
import './libs/easing.js';

import * as serviceWorker from './serviceWorker';

//import components
import Home from './components/home.jsx';
import PrivacyPolicy from './components/privacy-policy.jsx';


function App() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            </Routes>
        </Router>
    );
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
